import { get, http, IHttpResponse, post } from '../services/BackendService';
import { IPasswordStrength } from '../components/registration/SignupPassword';
import { isEmail } from '../utils/Validations';
import { ILookup } from '../features/login/loginSlice';
import { IDirectSignupState } from '../features/directSignup/directSignupSlice';
import { IDirectSignupRes } from '../components/registration/registration.interface';
import { buildDirectSignup, buildRequestURL } from '../utils/utils';
import { GenerateHatnameInterface } from '../interfaces/generate-hatname.interface';
import { HatTool } from '../interfaces/hat-tool.interface';
import { PdaVerificationRequest } from '../interfaces/pda-verification.interface';
import { IDaasSignup } from '../services/DaasSignupService';
import { AUTH_API_URL } from '../app.config';

export const validateEmail = async (email: string, sandbox: boolean) => {
  return get(`${AUTH_API_URL}/api/validate-email?email=${encodeURIComponent(email)}&sandbox=${sandbox}`);
};

export const validatePassword = async (email: string, password: string) => {
  const headers = {
    password: password,
  };
  const args: RequestInit = { method: 'get', headers: headers };

  return get<IPasswordStrength>(`${AUTH_API_URL}/api/validate-password`, args);
};

export const validateHatName = async (name: string, sandbox: boolean) => {
  return get(`${AUTH_API_URL}/api/validate-hatname?name=${name}&sandbox=${sandbox}`);
};

export const lookupLogin = async (username: string, sandbox: boolean) => {
  let path = `${AUTH_API_URL}/api/hat/lookup?sandbox=${sandbox}`;
  if (isEmail(username)) {
    path += `&email=${encodeURIComponent(username)}`;
  } else {
    path += `&name=${username}`;
  }

  return get<ILookup>(path);
};

export const postDirectSignup = async (signup: IDirectSignupState, sandbox: boolean) => {
  let path = `${AUTH_API_URL}/api/hat/signup`;

  return post<IDirectSignupRes>(path, buildDirectSignup(signup, sandbox));
};

export const createPdaAuthUser = async (signup: IDaasSignup, lang?: string | null, skipDeps?: string | null) => {
  let params: { [key: string]: string } = {};

  if (lang) {
    params['lang'] = lang;
  }

  if (skipDeps) {
    params['skipDeps'] = skipDeps;
  }

  const url = buildRequestURL(`${AUTH_API_URL}/api/services/daas/signup`, params);

  const args: RequestInit = {
    method: 'POST',
    body: JSON.stringify(signup),
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  return http<IDaasSignup>(new Request(url, args));
};

export const resendVerificationEmail = async (email: string, redirectUri: string, sandbox: boolean = false) => {
  let path = `${AUTH_API_URL}/api/services/daas/resend-verification`;
  const body: PdaVerificationRequest = {
    email: email,
    sandbox: sandbox,
    redirectUri: redirectUri,
  };

  return post(path, body);
};

export const generateHatName = async (email: string): Promise<IHttpResponse<GenerateHatnameInterface>> => {
  return get<GenerateHatnameInterface>(`${AUTH_API_URL}/api/generate-hatname?email=${encodeURIComponent(email)}`);
};

export const getFunction = async (functionId: string) => {
  return get<HatTool>(`${AUTH_API_URL}/api/functions/${functionId}`);
};
